export const REMOVE_ACTIVE_ROOM = 'REMOVE_ACTIVE_ROOM'

export const removedRoom = activeRoom => ({
	type: REMOVE_ACTIVE_ROOM,
	payload: activeRoom
})

export default function removeActiveRoom(updatedActiveRooms) {
	return dispatch => {
		dispatch(removedRoom(updatedActiveRooms))
	}
}



// WEBPACK FOOTER //
// ./src/actions/removeActiveRoomActions.js